// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sSjUe3QvhMb_CCAhhalR{color:var(--content-primary-tertiary);margin-top:16px;font-size:14px;font-weight:500;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageText": `sSjUe3QvhMb_CCAhhalR`
};
export default ___CSS_LOADER_EXPORT___;
